"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIsCookiePolicyShown = exports.getIsBridgeEnabled = exports.getIsPricingEnabled = exports.fetchEolConfig = exports.hasMonetizationStopped = undefined;

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _axios = require("axios");

var _axios2 = _interopRequireDefault(_axios);

var _moment = require("moment");

var _moment2 = _interopRequireDefault(_moment);

var _config = require("../../config");

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SET_EOL_CONFIG = "SET_EOL_CONFIG";
var SET_IS_LOADING = "SET_IS_LOADING";

var initialState = {
  isLoading: true,
  eolConfig: null,
  hasFabLaunched: false,
  hasMonetizationStopped: null
};

var hasMonetizationStopped = exports.hasMonetizationStopped = false;

var fetchEolConfig = exports.fetchEolConfig = function fetchEolConfig() {
  return function (dispatch) {
    return _axios2.default.get(_config2.default.eolConfigUrl).then(function (_ref) {
      var data = _ref.data;

      dispatch({
        type: SET_EOL_CONFIG,
        payload: data
      });
    }).catch(function (error) {
      console.error("Failed to fetch EOL config file:", error);
      dispatch({
        type: SET_IS_LOADING,
        payload: false
      });
    });
  };
};

var DEFAULT_EOL_CONFIG = {
  common: {
    fabLaunchDate: "Tue, 31 Dec 2024 00:00:00 GMT",
    cutOffDate: "Wed, 19 Feb 2025 00:00:00 GMT",
    commsReleaseDate: "Tue, 31 Dec 2024 00:00:00 GMT",
    stopMonetizingDate: "Tue, 17 Sep 2024 12:00:00 GMT",
    fabURL: "https://fab.com",
    quixelOnFabURL: "https://www.fab.com/sellers/Quixel",
    fabInLauncherURL: "com.epicgames.launcher://fab",
    excludedLicensees: ["studio", "studio-lite", "custom"]
  },
  inAppBanner: {
    enabled: true,
    content: "Megascans have a new home on <a id='fab-link' href='https://www.fab.com/sellers/Quixel' target='_blank'>Fab</a> and <a href='com.epicgames.launcher://fab' target='_blank'>Fab in the Epic Games Launcher</a>"
  },
  fabLaunchPopup: {
    enabled: true,
    title: "A new home for Megascans",
    content: "You can now find Quixel’s high-quality 3D assets on <a id='fab-link' href='https://www.fab.com/sellers/Quixel' target='_blank'>fab.com</a> or on <a href='com.epicgames.launcher://fab' target='_blank'>Fab in the Epic Games Launcher</a>.<br/><br/>Previously acquired assets and MetaHumans are still available on Quixel and Bridge.",
    learnMore: null,
    buttons: [{
      buttonText: "Stay here",
      buttonLink: "#CLOSE"
    }, {
      buttonText: "Visit Fab.com",
      buttonLink: "https://www.fab.com/sellers/Quixel"
    }]
  },
  autoRenewDeactivatedPopup: {
    enabled: false,
    title: "Your Quixel subscription is now free",
    content: "As we prepare for the launch of Fab, a few things are changing.<br/><br/>Starting today, all Megascans are free on Bridge and <a href='https://quixel.com' target='_blank'>Quixel.com</a> under the Epic Content License.<br/><br/>We're also turning off auto-renew on your purchased subscription. You will not be charged again for your subscription.<br/><br/>When Fab launches, if you have a balance of eligible points on your Quixel account, you will be able to request that they be either converted to Epic Wallet credit or refunded to you.",
    maxSeenCount: 1
  },
  redirectToFab: {
    enabled: true,
    content: "This asset is now available on <a id='fab-link' href='https://www.fab.com/sellers/Quixel' target='_blank'>FAB</a>."
  },
  pointsToCreditPopup: {
    enabled: true,
    title: "Action Required: Quixel Points",
    content: "Quixel points have been discontinued. You have a points balance ({{POINTS}}) that is eligible for conversion or refund. You will have until {{CUT_OFF_DATE}} to choose what you would like to do with your points.<br/><br/>Click below to get started.",
    message: null,
    buttons: [{
      buttonText: "Manage my points",
      buttonLink: "/convert-points",
      buttonVariant: "primary"
    }]
  },
  disabledSectionsPopup: {
    enabled: false,
    title: "Why can't I view Megascans?",
    content: "We have disabled some sections and functionality in the app for new users. You are seeing this popup because you're a new user and have joined us after <a id='fab-link' href='https://fab.com' target='_blank'>fab.com</a>'s launch, which is where you find the Megascans from now on. Older users will still be able to access Megascans in Bridge; they can re-download previously acquired assets. Moreover, depending on their license, older users may be able to download previously unacquired assets as well."
  },
  website: {
    heroBanner: {
      title: "Get Megascans",
      videoFile: "fab-assets-logo-looped-webcompressed.mp4",
      buttonText: "Shop now on Fab",
      buttonUrl: "https://www.fab.com/sellers/Quixel",
      link: {
        label: "Explore custom licensing options",
        href: "https://forms.unrealengine.com/s/quixel-contact-us"
      }
    },
    pricing: {
      isPricingEnabled: false,
      cutOffDate: "Tue, 31 Dec 2024 00:00:00 GMT"
    },
    isBridgeEnabled: true,
    isCookiePolicyShown: false
  },
  claimAll: {
    cutOffDate: "Tue, 31 Dec 2024 00:00:00 GMT",
    inAppBanner: {
      content: "Get all Legacy Megascans for free",
      buttonText: "Claim Now",
      buttonLink: "#OPEN_CLAIM_ALL_POPUP"
    },
    eligiblePopup: {
      title: "Claim Megascans",
      content: "You can claim legacy Megascans for free on Bridge and Quixel until December 31, 2024.<br/><br/>You'll be able to download and continue to use them under the <a id='fab-link' href='https://www.unrealengine.com/en-US/eula/content' target='_blank'>Epic Content License</a>.",
      buttons: [{
        buttonText: "No Thanks",
        buttonLink: "#CLOSE"
      }, {
        buttonText: "Claim",
        buttonLink: "#CLAIM_ALL",
        buttonVariant: "primary"
      }]
    },
    ineligiblePopup: {
      title: "Subscribe to a plan",
      content: "Subscribe to an Unreal Engine or Indie plan for free to claim legacy Megascans on Quixel.",
      buttons: [{
        buttonText: "Close",
        buttonLink: "#CLOSE"
      }, {
        buttonText: "Subscribe",
        buttonLink: "/pricing",
        buttonVariant: "primary"
      }]
    },
    successPopup: {
      title: "Legacy Megascans Claimed!",
      content: "To browse and download them, go to <strong>Purchased</strong> in the menu. It may take a few minutes for them to appear.",
      buttons: [{
        buttonText: "Done",
        buttonLink: "#CLOSE",
        buttonVariant: "primary"
      }]
    }
  }
};

var eol = function eol() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case SET_EOL_CONFIG:
      // const eolConfig =
      //   (process.env.NODE_ENV || "development") === "development"
      //     ? DEFAULT_EOL_CONFIG
      //     : action.payload;
      var eolConfig = action.payload;
      exports.hasMonetizationStopped = hasMonetizationStopped = !!(eolConfig && (0, _moment2.default)(new Date()).isAfter(eolConfig.common.stopMonetizingDate));
      return (0, _extends3.default)({}, state, {
        eolConfig: eolConfig,
        isLoading: false,
        hasFabLaunched: !!(eolConfig && (0, _moment2.default)(new Date()).isAfter(eolConfig.common.fabLaunchDate)),
        hasMonetizationStopped: hasMonetizationStopped
      });

    case SET_IS_LOADING:
      return (0, _extends3.default)({}, state, {
        isLoading: true
      });

    default:
      return state;
  }
};

var getIsPricingEnabled = exports.getIsPricingEnabled = function getIsPricingEnabled(eolConfig) {
  return eolConfig && eolConfig.hasOwnProperty("website") && eolConfig.website.hasOwnProperty("pricing") && eolConfig.website.pricing.hasOwnProperty("isPricingEnabled") && eolConfig.website.pricing.isPricingEnabled && !(0, _moment2.default)(new Date()).isAfter(eolConfig.website.pricing.cutOffDate);
};
var getIsBridgeEnabled = exports.getIsBridgeEnabled = function getIsBridgeEnabled(eolConfig) {
  return eolConfig && eolConfig.hasOwnProperty("website") && eolConfig.website.hasOwnProperty("isBridgeEnabled") && eolConfig.website.isBridgeEnabled;
};
var getIsCookiePolicyShown = exports.getIsCookiePolicyShown = function getIsCookiePolicyShown(eolConfig) {
  return eolConfig && eolConfig.hasOwnProperty("website") && eolConfig.website.hasOwnProperty("isCookiePolicyShown") && eolConfig.website.isCookiePolicyShown;
};

exports.default = eol;


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/eol.js
// module id = 185
// module chunks = 0